import React, {Component} from 'react';
import * as requiredCapabilitiesMapping
  from "../../constants/requiredCapabilitiesMapping";

class CapabilitiesSection extends Component {

  render() {
    const capabilitiesMap = requiredCapabilitiesMapping.capabilitiesMap;
    return (
        this.props.capabilities ? React.Children.map(this.props.children,
            (element) => {
              const componentDependencies = element.props.capabilitiesMappingId
                  ? capabilitiesMap[element.props.capabilitiesMappingId] : null;
              if (componentDependencies) {
                const display = componentDependencies.reduce(
                    (display, element) => {
                      return display && this.props.capabilities[element];
                    }, true);
                return display ? element : null
              }
              return element;
            })
            //In case of no capabilities — display only components without the additional requirements
            : React.Children.map(this.props.children,
            (element) => {
              return element.props.capabilitiesMappingId
              && capabilitiesMap[element.props.capabilitiesMappingId] ? null
                  : element;
            })
    );
  }
}

export default CapabilitiesSection;



// WEBPACK FOOTER //
// ./src/components/AddSAML/CapabilitiesSection.js